import chartTitles from '../chartTitles'
import withToolbar from '../withToolbar'
import LineChart from './LineChart'

export default withToolbar(LineChart, {
  pdfExport: {
    title: chartTitles.blood_oxygen
  },
  timeWindow: 7 * 12,
  childProps: {
    yMin: 50,
    type: 'blood_oxygen',
    yAxisLabel: 'Blood Oxygen Saturation (% SpO2)',
    title: 'Blood Oxygen Chart'
  }
})
